import React from 'react';

export default function Footer() {
    return (
        // <div className='fixed bottom-0 w-full bg-opacity-0 py-2 text-center'>
        //     <div className='flex justify-start px-20'>
        //         Powered by Zaptrance World Wide Systems Ltd
        //     </div>
        // </div>
        <div className='fixed left-0 bottom-0 w-full bg-opacity-0 py-2 text-center'  >
            <a target="_blank" href="https://www.zaptrance.ng">Powered by Zaptrance World Wide Systems Ltd</a>
        </div>
    )
}